import { createSlice } from "@reduxjs/toolkit";
import { NewEmployeeDataProps } from "../profile/types";

const initialState: NewEmployeeDataProps = {
  emp_code: "",
};

const newEmployeeReducer = createSlice({
  name: "employee",
  initialState: initialState,
  reducers: {
    set_NewEmp(state, action) {
      state.emp_code = action.payload;
    },
  },
});

export default newEmployeeReducer.reducer;

export const { set_NewEmp } = newEmployeeReducer.actions;
